import { InjectionToken } from '@angular/core';

export const NEW_DESIGN = new InjectionToken<boolean>('New design flag');
export const KROS_DESIGN_VERSION = new InjectionToken<number>('Design system version');
